<div class="custom-button"
    [ngClass]="{ 'selected': isSelected, 'disabled': isDisabled }">
  <label>{{ label }}</label>

  <div class="beta-chip-wrapper" *ngIf="isBeta" >
    <app-chip id = "beta" [text]="'Beta'" [type]="betaBadgeDetails" />
  </div>
</div>
